<template>
  <div>
    <el-dialog
      top="20vh"
      width="650px"
      :visible.sync="isApplyRefund"
      center
      append-to-body
      :before-close="cancalDailog"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div slot="title">{{flag ? '一键退款' : '发起退款'}}</div>
      <div v-if="row.oilInvoiceStatus === 1" class="tips">
        <el-alert v-if="flag" type="error" center :closable="false">
          <span slot="title"><i class="el-icon-warning"></i> 此订单已开票成功，点击确认退款后，钱款将直接退款给车主</span>
        </el-alert>
        <el-alert v-else type="error" center :closable="false">
          <span slot="title"><i class="el-icon-warning"></i> 此订单已开票成功</span>
        </el-alert>
      </div>
      <el-form v-if="isApplyRefund" ref="refund" :rules="refundRules" :model="refundOptions" label-width="90px" size="mini">
        <el-form-item label="订单选择:" prop="refundOrderType">
          <el-select v-model="refundOptions.refundOrderType" size="middle" style="width:420px" placeholder="请选择" >
            <!-- <el-option label="整单退" :value="1" :disabled="!hasUnOilUnRefund"></el-option> -->
            <el-option label="退油品订单" :value="2" :disabled="hasUnOilUnRefund"></el-option>
            <el-option label="退非油品订单" :value="3" :disabled="!hasUnOilUnRefund"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退款金额:">
          <div>{{refundOptions.refundOrderType === 2 ? `¥${row.amountGun}` : refundOptions.refundOrderType === 3 ? `¥${payAmount}` : '--'}}</div>
        </el-form-item>
        <el-form-item label="订单编号:">
          <div>{{refundOptions.refundOrderType === 2 ? row.orderId : refundOptions.refundOrderType === 3 ? unOilOrderId : '--'}}</div>
        </el-form-item>
        <el-form-item label="退款原因:" prop="refundType" v-if="refundOptions.refundOrderType !== 3">
          <el-select v-model="refundOptions.refundType" size="middle" style="width:420px" placeholder="请选择退款原因">
            <el-option v-for="(item,index) in reasonList" :key="index" :label="item" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="remark" v-if="refundOptions.refundOrderType !== 3">
          <el-input
            type="textarea"
            :rows="7"
            :placeholder="refundOptions.refundType !== '999' ? '请填写退款原因' : '5-200个字，必填 请您补充详细退款原因能够提高退款时效哦~'"
            minlength="5"
            maxlength="200"
            show-word-limit
            v-model="refundOptions.remark"
            class="text-area"
            style="width:420px"
            @submit.native.prevent>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancalDailog">取 消</el-button>
        <el-button type="primary"  @click="closeDailog(1)">确认退款</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { submitRefund, getRefundReason, nonOilRefund } from '@/api/order'
export default {
  props: {
    row: {
      type: Object
    }
  },
  data () {
    return {
      btnLoading: false,
      isApplyRefund: false,
      refundOptions: { // 退款选项
        refundOrderType: null,
        refundType: '',
        remark: ''
      },
      reasonList: [],
      hasUnOilUnRefund: false, // 有非油品未退款
      unOilOrderId: '',
      payAmount: '--',
      flag: '', // 区分一键退款还是发起退款
    }
  },
  computed: {
    refundRules () {
      return {
        refundOrderType: [
          { required: true, message: '请选择订单', trigger: 'change' }
        ],
        refundType: [
          { required: true, message: '请选择退款原因', trigger: 'change' }
        ],
        remark: [
           { required: this.isOther, message: '请补充详细退款原因', trigger: 'blur' },
           { min: 5, max: 200, message: '长度在 5 到 200 个字符', trigger: 'blur' }
        ]
      }
    },
    isOther () {
      return this.refundOptions.refundType === '999'
    }
  },
  methods: {
    async init (orderId, flag) {
      this.flag = flag
      this.initRefundReason()
      const { code, result } = await nonOilRefund({ orderId })
      if (code !== 200) return
      this.hasUnOilUnRefund = (result && result.status !== 4) || false
      this.unOilOrderId = result && result.nonOilOrderNo
      this.payAmount = result && result.payAmount
      this.isApplyRefund = true
    },
    // 原因枚举
    async initRefundReason () {
      try {
        const { code, result } = await getRefundReason()
        if (code !== 200) return
        this.reasonList = result
      } catch (error) {
        console.log(error)
      }
    },
    // 取消退款
    cancalDailog () {
      this.reset()
      this.isApplyRefund = false
    },
    reset () {
      this.refundOptions = {
        refundType: '',
        remark: ''
      }
    },
    // 确认退款
    closeDailog () {
      this.$track.clickEvent('团油订单申请退款', '1621001383')
      this.$refs.refund.validate((vaild) => {
        if (!vaild) return
        this.submitRefund()
      })
    },
    async submitRefund () { // 提交退款信息
      let params = { ...this.refundOptions, orderId: this.hasUnOilUnRefund ? this.unOilOrderId : this.row.orderId }
      if (this.flag) params.pageOptRefundType = 1 // 代表是一键退款，而不是发起退款。（其实一样，但是后端逻辑不一样）
      try {
        const { code, message } = await submitRefund(params)
        if (code === 13560) {
          this.$alert(message, '退款异常提示', { confirmButtonText: '知道了', type: 'warning' })
          return
        }
        if (code !== 200) return this.$message.error(message || '退款失败')
        this.$message.success('已成功提交退款信息')
        this.$emit('handleApply')
      } catch (error) {
        console.log(error.message)
      } finally {
        this.$emit('handleApply')
        this.reset()
        this.isApplyRefund = false
      }
    },
  }
}
</script>
<style lang="less" scoped>
.tips{
  padding: 0 0 20px 0;
}
.cancel-btn{
  width: 100px;
  height: 40px;
  border-radius: 1px;
  border: 1px solid #C5C9D0;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.true-btn{
  width: 100px;
  height: 40px;
  text-align: center;
  background: #4B7EFE;
  box-shadow: 0px 1px 4px 0px rgba(16,67,193,0.2);
  border-radius: 1px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  text-shadow: 0px 1px 4px rgba(16, 67, 193, 0.2);
}
</style>